/* eslint-disable max-lines */
/* eslint-disable react/jsx-one-expression-per-line */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import { Fonts } from '@styles/index';
import P1 from '@base/P1/P1';
import H2 from '@base/H2/H2';
import Layout from '@layout/index';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const StyledLink = styled.a`
  color: var(--color-i-blue);
`;

const Line = styled.li`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: var(--color-text-primary);
  margin: 0px;
`;

const Terms = () => {
  const { pathname, query } = useRouter();
  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>
      <RightContainer>
        {query.in_app !== 'true' && (
          <H2>Terms & Conditions – Unacademy Referral</H2>
        )}
        <br />
        <br />
        <br />
        <P1>
          Unacademy Learner Referral Program <b>(“Referral Program”)</b> is made
          available through the Platform to all Learners (as defined in our{' '}
          <StyledLink href="/terms">Terms and Conditions</StyledLink>) who are
          paid Subscribers on the Platform.
          <br />
          <br />
          When we refer to <b>“you”/ “your/s”</b>, we collectively mean you as
          the Learner on the Platform. Similarly, when we speak of{' '}
          <b>“Unacademy”, “we”, “us”,</b> and <b>“our”</b>, we collectively mean{' '}
          <b>Sorting Hat Technologies Private Limited</b> – a company
          incorporated in India and all its affiliates which have a license to
          host the Platform and offer Services. Kindly refer to the{' '}
          <StyledLink href="/terms#about">
            About Unacademy and the Platform
          </StyledLink>{' '}
          section of the Terms and Conditions to know which Unacademy entity
          your Agreement (
          <i>
            as defined in{' '}
            <StyledLink href="/terms">Terms and Conditions</StyledLink>
          </i>
          ) will be with.
          <br />
          <br />
          Participation in our Referral Program is subject to the following
          terms and conditions (<b>“Referral Terms”</b>). Please take the time
          to read our Referral Terms and Platform Terms (as defined below). By
          participating in our Referral Program, you acknowledge that you have
          read, understood, and agree to be legally bound by the terms and
          conditions of these Referral Terms along with the Unacademy’s{' '}
          <StyledLink href="/terms">Terms and conditions</StyledLink>,{' '}
          <StyledLink href="/privacy">Privacy Policy</StyledLink> and any other
          terms and conditions updated on the Platform or communicated to you
          from time to time (collectively referred to as the{' '}
          <b>“Platform Terms”</b>). If you do not agree to any of the terms and
          conditions, then please do not participate in our Referral Program or
          use our Service (as defined in our Terms and Conditions).
          <br />
          <br />
          Capitalized terms not defined in these Referral Terms shall have the
          meaning set forth in our Platform Terms.
          <br />
          <br />
          We may change these Referral Terms from time to time and will post any
          changes on the Platform or notify you via email, at our option, as
          soon as such changes are in effect.
          <br />
          <br />
        </P1>
        <Line>
          <b>Eligibility and Participation:</b> Participation in the Referral
          Program is voluntary, and all Learners on the Platform are eligible to
          participate in the Referral Program. Accordingly, the ‘
          <StyledLink href="/terms#rights_to_accounts">
            Age Requirements
          </StyledLink>
          ’ as stated in our Platform Terms shall continue to apply to all
          Learners participating in the Referral Program.
          <br />
          <br />
          <ol type="a">
            <Line>
              Once registered on the Platform as a Learner, you will have the
              option to generate a referral code within your account on the
              Platform or otherwise as directed on the Platform or as may be
              communicated to you by Unacademy in writing (emails included)
              <b>(“Referral Code”)</b>.{' '}
            </Line>
            <Line>
              You may refer friends or anyone by sending them the Referral Code
              via the Platform, email or through any other mode or platform.
            </Line>
            <Line>
              Once a person registers on the Platform as a Learner and purchases
              a Subscription (as defined in our{' '}
              <StyledLink href="/terms">Terms and conditions</StyledLink>) using
              your Referral Code, such person shall be considered as your{' '}
              <b>“Qualified Referral”</b>.
            </Line>
          </ol>
          <br />
          Please note that Referral Codes are unique to each Learner, and only
          when the person registering as a Learner applies your Referral Code
          will he/she/they be considered as your Qualified Referral. In other
          words, if the person you referred has failed to enter/apply the
          Referral Code that is unique to you while registering as a Learner or
          purchasing a Subscription (as applicable) on the Platform, then such
          person shall not be considered as your Qualified Referral, and you
          shall not be eligible to receive any Referral Rewards (defined below)
          in respect of that person. Similarly, any failure on your part to
          display or share the correct Referral Code shall not be the
          responsibility of Unacademy.
        </Line>
        <br />
        <Line>
          <b>A ‘Qualified Referral’ does NOT include the following:</b>
          <br />
          <ol type="a">
            <Line>
              Self-Referrals shall not be deemed as a Qualified Referral and
              Referral Rewards are not valid or payable for Self-Referrals. So,
              if your personal details, including but not limited to, last name,
              email address, IP address or website details, are the same as your
              Qualified Referral(s), then such referral will be deemed as a{' '}
              <b>“Self-Referral”</b>. Unacademy, in its sole discretion, will
              determine the classification of any referral as a{' '}
              <b>“Self-Referral”</b>.
            </Line>
            <Line>
              Referrals made to any existing Learners on the Platform shall not
              be deemed as Qualified Referrals; only a new user registering on
              the Platform using your Referral Code shall be considered as your
              Qualified Referral.
            </Line>
            <Line>
              If a Learner referred by you initiates cancellation or refund of
              the Subscription on the Platform within 30 (thirty) days (or such
              other number of days as mentioned on the Platform) from the date
              of purchase of the Subscription on the Platform, or if there have
              been any chargebacks by such Learner, then such Learner referred
              by you shall not be deemed as a Qualified Referral, and you shall
              not be entitled to any Referral Rewards in respect of such
              Learner.
            </Line>
            <Line>
              No referral by you shall be considered as a Qualified Referral, if
              Unacademy suspects any fraudulent activity by you to increase your
              Qualified Referrals, including without limitation, the use of any
              software that generates real and fictitious information, multiple
              accounts from the same users referred by you, or any activity that
              does not comply with the Referral Terms and/or the Platform Terms.
              In these cases, Unacademy shall also have the right to terminate
              your account and access to the Platform at its sole discretion.
            </Line>
            <Line>
              Where any Learner referred by you receives from or was offered
              coupons, refunds, credits or discounts by you to purchase a
              Subscription on the Platform and such offering was a not
              authorised by Unacademy, then such purchase by the Learner
              referred by you shall not amount to a Qualified Referral.
            </Line>
            <Line>
              If it is found by Unacademy that you have adopted marketing
              practices in contravention to these Referral Terms or that we deem
              to be unethical or are likely to attract fraudulent signups, then
              such Learners referred by you shall not be deemed as Qualified
              Referrals.
            </Line>
            <Line>
              Any referral that is deemed to be in contravention of these
              Referral Terms, Platform Terms and/or any other terms as
              communicated to you by Unacademy in writing (emails included) at
              the sole discretion of Unacademy, shall not be deemed as a
              Qualified Referral.
            </Line>
          </ol>
        </Line>
        <br />
        <Line>
          <b>Referral Rewards:</b> For each Qualified Referral you may be
          entitled to receive a reward in the form of cash, gift vouchers or
          otherwise in kind as detailed out{' '}
          <StyledLink href="/helpcenter/category/81000193487/article/81000383213">
            here
          </StyledLink>{' '}
          or elsewhere on the Platform and/or as communicated to you in writing
          (emails included) from time to time (<b>“Referral Rewards”</b>) (as
          defined below). These Referral Rewards, and the duration for which
          these Referral Rewards are offered, are as detailed out on the
          Platform and/or as communicated to you in writing (emails included).
          The Referral Rewards shall be determined by Unacademy at its sole
          discretion and the same may vary from time to time, unless otherwise
          specifically communicated to you in writing (emails included).
          <br />
          <br />
          It is hereby clarified that the Referral Rewards shall be inclusive of
          all applicable taxes and subject to deduction of applicable taxes.
          Unacademy shall not be responsible to pay any taxes on the Referral
          Rewards in any manner.
        </Line>
        <br />
        <Line>
          <b>Disbursement of Referral Rewards:</b> We will track the Qualified
          Referrals generated by you through your Referral Code, and we will
          make this information available to you either on your dashboard on the
          Platform or otherwise communicate to you (including via email). To
          permit accurate tracking, reporting, and commission accrual, you must
          ensure that the Referral Codes are properly made available to your
          referrals. Further, please note the below-
          <ol type="a">
            <Line>
              Based on your Qualified Referrals, you shall be entitled to such
              Referral Rewards as determined by Unacademy at the time of its
              accrual. The information regarding the Referral Rewards you may be
              entitled to shall be made available to you either on your
              dashboard or shall be communicated to you by Unacademy including
              via email.
            </Line>
            <Line>
              The Referral Rewards shall be disbursed to you upon you claiming
              the same either through your dashboard or through such other
              mechanism as may be communicated to you by Unacademy. Unless duly
              claimed by you in accordance with the mechanism communicated by
              Unacademy, Unacademy shall not be obligated to disburse any
              Referral Reward to you on any account whatsoever.
            </Line>
            <Line>
              You are entitled to Referral Rewards only for your Qualified
              Referrals as verified by Unacademy in accordance with these
              Referral Terms and other terms as may be communicated to you in
              writing (emails included).
            </Line>
            <Line>
              Referral Rewards shall be disbursed to you based on the current
              information provided by you on the Platform, including your email
              address and phone number. In case of any changes, it shall be your
              sole responsibility to update the information in your dashboard or
              by writing to{' '}
              <StyledLink href="mailto:help@unacademy.com">
                help@unacademy.com
              </StyledLink>
              , and Unacademy shall not be liable for the same.
            </Line>
            <Line>
              If there are any cash-based Referral Rewards, then the payment of
              same may be facilitated to you subject to your submission of the
              required ‘Know your Customer’ (KYC) documents, and any other tax
              related documents as may be required by Unacademy.
            </Line>
            <Line>
              It is hereby clarified that the Referral Rewards shall be
              inclusive of all applicable taxes and subject to deduction of
              applicable taxes. Unacademy shall not be responsible to pay any
              taxes on the Referral Rewards in any manner.
            </Line>
            <Line>
              Unacademy reserves the right to withhold disbursement of Referral
              Rewards if it is determined that you have referrals that are in
              contravention of these Referral Terms and/or any terms as may be
              communicated to you in writing (emails included).
            </Line>
            <Line>
              Unacademy reserves the right to immediately cancel or withhold for
              later review any Referral Rewards that fail to meet the criteria
              of a ‘Qualified Referral’. You are responsible for monitoring the
              disbursement, denial, and withholding of Referral Rewards;
              Unacademy is not obligated to actively notify you of the status of
              the Referral Rewards except as stated hereunder. If you have any
              questions about your Referral Rewards that have been cancelled or
              withheld, you have thirty (30) days from the day such Referral
              Reward would have accrued to contact Unacademy requesting the
              information for such cancellation or withholding. Any changes to
              decisions about cancelled or withheld Referral Reward are strictly
              made in Unacademy’s sole discretion
            </Line>
          </ol>
        </Line>
        <br />
        <Line>
          <b>Marketing and Promotions: </b>
          <ol type="a">
            <Line>
              You shall bear your own costs and expenses related to marketing
              and promoting Unacademy. Unacademy is not obligated to reimburse
              or credit you for any marketing expenses, unless it has been
              specifically agreed by Unacademy in writing (emails included).
            </Line>
            <Line>
              You hereby represent and warrant that your marketing practices do
              not violate any of the following restrictions. you shall -
              <ol type="i">
                <Line>not advertise Unacademy as a free product.</Line>
                <Line>
                  not make any false, misleading, or disparaging statements with
                  respect to the Unacademy, its employees, its customers, its
                  affiliates, its Services, or the Referral Program.
                </Line>
                <Line>
                  not use traffic that is generated by, including, but not
                  limited to, pay to click, pay to read, banner exchanges, click
                  exchanges, cost-per-view advertising, pop-up/under, spam,
                  purchased traffic, or similar methods without prior written
                  consent from Unacademy.
                </Line>
                <Line>
                  not create websites or advertisements that copy, imitate, or
                  resemble the look and feel of Unacademy’s Services.
                </Line>
                <Line>
                  not engage in the advertisement of business-opportunity
                  websites or use marketing practices that attract fraudulent or
                  short-term customers.
                </Line>
                <Line>
                  not engage in any marketing activity that may harm the
                  reputation or credibility of Unacademy, including but not
                  limited to using low-quality marketing materials, or
                  advertising on any website that promotes violence,
                  discrimination based on race, sex, religion, nationality,
                  disability, sexual orientation or age, or any illegal
                  activities, or violates the intellectual property or other
                  rights of a third party.
                </Line>
                <Line>
                  include a physical mailing address and unsubscribe information
                  for any marketing email sent promoting Unacademy’s Services.
                </Line>
                <Line>
                  communicate clearly that they, not Unacademy, are the sender
                  of all marketing communications related to the promotion of
                  Unacademy’s Services as part of the Referral Program.
                </Line>
                <Line>
                  not engage in any marketing or promotional activities that
                  violate applicable laws, rules, or regulations.
                </Line>
                <Line>
                  not market using facsimile, broadcast, telemarketing, text
                  message marketing, or other offline marketing methods
                  regarding Unacademy and/or its Services without the express
                  written consent of Unacademy.
                </Line>
                <Line>
                  not use malware or spyware to market or promote Unacademy’s
                  Services.
                </Line>
              </ol>
            </Line>
          </ol>
        </Line>
        <br />
        <Line>
          <b>Coupons and Promotional Codes: </b> You may only use coupons and
          promotional codes that are provided exclusively through the Referral
          Program. We do not provide any rewards or incentives to Qualified
          Referrals, unless otherwise specifically communicated in writing
          (digital medium included), and Unacademy reserves the right to cancel
          any and all Referral Rewards where it finds evidence of any activity
          run by you that claims or otherwise communicates offering of rewards
          or incentives to Qualified Referrals by Unacademy. Further, we do not
          encourage you to offer such incentives or rewards to promote the use
          of your Referral Code in any manner.
        </Line>
        <br />
        <Line>
          <b>Prohibited Activities: </b>
          <ol type="a">
            <Line>
              Except as permitted herein, you shall not and are not authorized
              to –
              <ol type="i">
                <Line>
                  use Unacademy’s trademark or other intellectual property,
                  including without limitation, the Referral Codes
                  (collectively,{' '}
                  <b>“Unacademy’s Intellectual Property” or “Unacademy’s IP”</b>
                  ) without Unacademy’s express prior written permission;
                </Line>
                <Line>
                  use Unacademy’s name (or any variation or misspelling thereof
                  or other terms that are confusingly similar to any of the
                  foregoing) in a domain name, any metatags, advertising, search
                  terms, code, or otherwise; or
                </Line>
                <Line>
                  act in any way that causes or could cause any confusion
                  concerning the source of, or your association with Unacademy’s
                  Services. Your use of Unacademy’s IP in any manner, other than
                  as expressly permitted hereunder and/or as communicated to you
                  by Unacademy in writing (emails included) shall constitute
                  infringement of Unacademy’s IP rights and Unacademy shall have
                  the right to enforce its rights against you which may subject
                  you to liabilities including without limitation to pay
                  Unacademy’s legal fees and costs.
                </Line>
              </ol>
            </Line>
            <Line>
              You are prohibited from bidding on any Unacademy trademarks, or
              any variations and misspellings thereof. <b>Examples</b> of
              prohibited keywords are “Unacademy”, “Un-academy” “Unacademyapp”,
              “Unacademy.com”, “Unacademy.in”, “Unacademyapp.co”,
              “india.Unacademy.com,&#34; “Unacademy hosting”, “Unacademy
              domains”.
            </Line>
            <Line>
              You are prohibited from bidding on keywords containing Unacademy
              trademarks plus an additional term such as [Unacademy coupons],
              [Unacademy promotions], and [Unacademy promos]. Further, you are
              NOT permitted to phrase match any of these keywords.
            </Line>
            <Line>
              You are prohibited from outranking Unacademy&#39;s internal paid
              search ad on any keywords.
            </Line>
            <Line>
              You are prohibited from direct linking to the Platform from any
              paid search ads.
            </Line>
            <Line>
              You are prohibited from using{' '}
              <StyledLink href="/">www.unacademy.com</StyledLink> as a display
              URL.
            </Line>
            <br />
            If you are determined to be in violation of this section, then your
            participation in the Referral Program may be terminated. For more
            information on match types, please visit Google&#39;s overview of{' '}
            <StyledLink href="https://support.google.com/google-ads/answer/7478529?hl=en&visit_id=637175332283452149-3617255890&rd=1">
              match types
            </StyledLink>
            .
          </ol>
        </Line>
        <br />
        <Line>
          <b>IP Licenses and Use: </b>
          <br />
          Subject to the limitations set forth in these Referral Terms, we grant
          you a non-exclusive, non-transferable, non-assignable, revocable
          license to (i) provide access to Unacademy’s website through the
          Referral Codes solely in accordance with these Referral Terms; and
          (ii) use Unacademy’s IP for the sole purpose of promoting Unacademy’s
          Services in accordance with these Referral Terms and/or any terms as
          may be communicated to you in writing (emails included).
          <br />
          <br />
          You shall not alter, modify, or change Unacademy’s IP in any way or
          use Unacademy’s IP in any manner that is disparaging or that otherwise
          portrays Unacademy, any Unacademy employee, representative or customer
          in a negative light. You are only entitled to use Unacademy’s IP in
          compliance with these Referral Terms, Platform Terms and/or any terms
          as may be communicated to you in writing (emails included).
          <br />
          <br />
          Your license to use Unacademy’s IP shall immediately terminate upon
          the termination of your participation in the Referral Program for any
          reason. We reserve all of our rights in Unacademy’s IP and your
          license to use Unacademy’s IP is limited to the manner described
          herein.
        </Line>
        <br />
        <Line>
          <b>General Terms: </b>
          <ol type="a">
            <Line>
              Unacademy reserves the right to modify or cancel the Referral
              Program in its entirety without prior notice. Similarly, Unacademy
              reserves the right to modify, add or delete any of the terms under
              this Referral Terms at any point of time at its sole discretion
              without serving any prior intimation. Intimation of any change,
              modification, addition, deletion in the Referral Terms will be
              updated on this page or in the relevant section of the Platform.
            </Line>
            <Line>
              Referral Rewards are non-transferable; non-endorsable; non-
              exchangeable for equivalent amount of money or anything of value.
              Unacademy does not promise/promote to do the same.
            </Line>
            <Line>
              Referral Rewards are time-bound, and accordingly the same must be
              availed within the duration specified on the Platform and/or as
              communicated to you in writing (emails included).
            </Line>
            <Line>
              Unacademy reserves the right to cancel, revoke, or otherwise
              prevent the issuance of Referral Rewards in any suspected case of
              fraudulent use or misuse of this Referral Program. Spam and/or
              illegal emails are not permitted.
            </Line>
          </ol>
        </Line>
        <br />
        <br />
        <P1>
          <i>
            Referral Terms and Conditions – Version 2.0
            <br />
            Last Updated on 22 March, 2022
          </i>
        </P1>
      </RightContainer>
    </>
  );
};

Terms.pageInfo = {
  name: 'Unacademy Referral Terms',
  isMWebSupported: true,
  layoutOptions: {
    disableDarkMode: true
  }
};

export default Terms;
Terms.Layout = Layout;
Terms.Wrapper = PageReduxProvider;
